import { styled } from '@mui/material/styles';

export const PageContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(3),
    height: '100%',
}));